import { Link } from 'react-router-dom'

export const ShopMarketplaceButtons = () => {
    return (
        <div className='flex flex-col gap-3 w-full max-w-xs'>
            <Link
                to='/store'
                className='bg-br1-gradient p-4 font-black uppercase text-center text-sm tracking-widest rounded-lg hover:outline'
            >
                VISIT SHOP
            </Link>
            <Link
                to='/marketplace'
                className='bg-br1-gradient p-4 font-black uppercase text-center text-sm tracking-widest rounded-lg hover:outline'
            >
                EXPLORE MARKETPLACE
            </Link>
        </div>
    )
}
